import React from 'react';
import PropTypes from 'prop-types';

const CustomTd = ({
    children,
    className,
    content,
    hide,
    show,
    style,
    width,
    ...passThroughProps
}) => {
    const classes = hide ? `d-none d-${hide}-table-cell` : show ? `d-table-cell d-${show}-none` : '';

    const widthStyle = width ? { width: width } : {}

    return (
        <td
            {...passThroughProps}
            className={`${className || ''} ${classes}`}
            style={{ ...style, ...widthStyle }}
        >
            <div className='animation-wrapper'>
                {content}
                {children}
            </div>
        </td>
    );
}

CustomTd.propTypes = {
    className: PropTypes.string,
    colSpan: PropTypes.number,
    content: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.object,
        PropTypes.string
    ]),
    hide: PropTypes.string
};

export default CustomTd;